module.exports = __webpack_public_path__ + "static/media/feature.0efc52f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BusinessNews/feature.jpg
// module id = 274
// module chunks = 0